const CLEAN = {
    onReady() {
        CLEAN.buttons();
        CLEAN.formBetweenTeaser();
        CLEAN.textBlocksAfterForm();
        CLEAN.grids();
        CLEAN.exposeTeaser();
        CLEAN.exposeSlider();
        CLEAN.marginAfterExposeDetail();
        CLEAN.singleFormButton();
        CLEAN.accessibilityFormTextContrast();
        CLEAN.textRightToCenter();
        CLEAN.responsiveImages();
        CLEAN.hideMobile();
        CLEAN.highlightJumpMark();
        window.addEventListener('popstate', CLEAN.highlightJumpMark);
    },
    /*********************
    * Remove margin-bottom values from surrounding paragraph
    *********************/
    buttons() {
        let buttons = document.querySelectorAll('.button, .button--standard, .button--cta');
        buttons.forEach(button => {
            let parent = button.parentNode;
            (parent.tagName === 'P') && (parent.style.marginBottom = '0');
        });
    },
    /*********************
    * Adjust space between form and blog teasers
    *********************/
    formBetweenTeaser() {
        let sections = document.querySelectorAll('.blog-teaser');
        sections.forEach(section => {
            let sibling = section.nextElementSibling;
            if (sibling === null || !sibling.classList.contains('form-wrapper') ) return;            
            Object.assign(section.style, {
                marginBottom: 'var(--gutterSpace)',
                paddingBottom: '0'
            });
            Object.assign(sibling.style, {
                margin: '0 auto var(--gutterSpace) auto'
            });
            let nextSibling = sibling.nextElementSibling; 
            if (nextSibling === null || !nextSibling.classList.contains('blog-teaser') ) return; 
            Object.assign(nextSibling.style, {
                marginTop: '0',
                paddingTop: '0'
            });
        });
    },
    /*********************
    * Adjust space after form when the following element is a text-block
    *********************/
    textBlocksAfterForm() {
        let sections = document.querySelectorAll('.form-wrapper.inline');
        sections.forEach(section => {
            let sibling = section.nextElementSibling;
            if (sibling === null || !sibling.classList.contains('text-editor') ) return;
            section.style.marginBottom = '0';
        });
    },
    /*********************
    * Remove margin button of last element of grid item
    *********************/
    grids() {
        let contents = document.querySelectorAll('.grid__content');
        contents.forEach(content => {
            content.lastElementChild.style.marginBottom = '0';
        });
    },
    /*********************
    * Adjust images of expose previews
    *********************/
    exposeTeaser() {
        if (window.innerWidth < 720) return;
        let teasers = document.querySelectorAll('.js-expose-teaser');
        teasers.forEach(teaser => {
            teaser.querySelector('.js-expose-teaser-image').style.paddingLeft = `${teaser.clientHeight}px`;
        });
    },
    /*********************
    * Position Expose Slider in Detail View
    *********************/
    exposeSlider() {
        if (window.innerWidth < 1232) return;
        let anchor = document.getElementById('js-slider-position-anchor');
        let slider = document.getElementById('js-slider-position');
        if (anchor === null || slider === null) return;
        slider.style.top = `calc(${anchor.offsetTop}px + 3rem)`; // Offset + Element Height + Margin Bottom
    },
    /*********************
    * adjust Margin after expose detail
    *********************/
    async marginAfterExposeDetail() {
        const result = await TINYSLIDER.slider()
        if (window.innerWidth < 1232) return;
        const exposeDetail = document.querySelector('.expose-detail');
        const slider       = document.getElementById('js-slider-position');
        if (exposeDetail === null || slider === null) return;
        let exposeDetailOffsetBottom = exposeDetail.offsetTop + exposeDetail.clientHeight;
        let sliderOffsettBottom      = slider.offsetTop + slider.clientHeight;
        let delta                    = sliderOffsettBottom - exposeDetailOffsetBottom;
        exposeDetail.style.marginBottom = (delta > 0) ? `calc(4.75rem + ${ delta }px)` : `4.75rem`;
    },
    /*********************
    * Beautify forms with ONLY ONE input field
    *********************/
    singleFormButton() {
        if (window.innerWidth < 870) return;
        let forms = document.querySelectorAll('.form');
        forms.forEach(form => {
            let inputs = form.querySelectorAll('input:not([type="hidden"])');
            let button = form.querySelector('.button--cta');
            if (inputs.length === 1) {
                Object.assign(button.style, {
                    position: 'absolute', 
                    top: '.25rem', 
                    right: '0', 
                    height: '3.375rem'
                });
                inputs[0].style.width = `calc(100% - 1rem - ${button.clientWidth}px )`;
            }
        });
    },
    /*********************
    * Contrast of text and Background in Forms
    *********************/
    accessibilityFormTextContrast() {
        let formWrappers = document.querySelectorAll('.form-wrapper');
        formWrappers.forEach(wrapper => {
            let bgStyleValue = wrapper.style.backgroundColor; // if hex it gets auto-convert to rgb values, alternative it can be a CSS-variable
            if (bgStyleValue === '') return;
            let regex    = new RegExp(/\s*\(.*?\)\s*/g);
            let value    = bgStyleValue.match(regex)[0].replace('(', '').replace(')', '');
            let valueArr = value.split(',');
            if (valueArr.length === 1) { // css variable
                let hex = getComputedStyle(document.documentElement).getPropertyValue(value);
                hex = hex.replace('#', '');
                let bigint = parseInt(hex, 16);
                var r = (bigint >> 16) & 255;
                var g = (bigint >> 8) & 255;
                var b = bigint & 255;
            } else { // hex color
                var r = parseInt(valueArr[0]);
                var g = parseInt(valueArr[1]);
                var b = parseInt(valueArr[2]);
            }
            let threshold  = 130; // about half of 256. Lower threshold equals more dark text on dark background
            let brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000; // W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast
            if (brightness > threshold) {
                var textColor = '#000000';
            } else { 
                var textColor = '#ffffff';
            }
            let headings  = wrapper.querySelectorAll('.form__heading');
            let itemNames = wrapper.querySelectorAll('.form__item__name');
            let legals    = wrapper.querySelectorAll('.form__legal-notice');
            [headings, itemNames, legals].forEach(elements => {
                elements.forEach(element => {
                    (element !== null) && (element.style.color = textColor);
                })
            });
        });
    },
    /*********************
    * Clean text alignment on mobile, reset fixed image width
    *********************/
    textRightToCenter() {
        if (window.innerWidth > 870) return;
        let textModules = document.querySelectorAll('.text-editor');
        let gridModules = document.querySelectorAll('.grid');
        [textModules, gridModules].forEach(modules => {
            modules.forEach(module => {
                let items = module.querySelectorAll('*');
                items.forEach(item => {
                    let children = Array.from(item.children); 
                    children.forEach(child => {
                        (child.style.textAlign === 'right') && (child.style.textAlign = 'center');
                    });
                });
            });
        });
    },
    /*********************
    * Remove fixed width from images if they expand the screen size
    *********************/
    responsiveImages() {
        let images = document.querySelectorAll('img');
        images.forEach(image => {
            (parseInt(image.style.width) > window.innerWidth) && (Object.assign(image.style, {width: '100%', height: 'auto'}));
        });
    },
    /*********************
    * Remove parent from mobile hidden elements
    *********************/
    hideMobile() {
        if (window.innerWidth > 680) return;
        let hiddenElements = document.querySelectorAll('.hide-mobile');
        hiddenElements.forEach(element => {
            let parentParagraph = element.closest('p');
            if (parentParagraph === null) return;
            parentParagraph.remove();
        });
    },
    /*********************
    * Highlight jumpmark container
    *********************/
    highlightJumpMark() {
        let urlHash    = window.location.hash;
        let containers = document.querySelectorAll('[data-jumpmark]');
        if (urlHash === '') return;
        if (containers.length === 0) return;
        containers.forEach(container => {
            container.classList.remove('jumpmark-highlight');
            (urlHash.replace('#', '') === container.dataset.jumpmark) && container.classList.add('jumpmark-highlight');
        });
        const burger = document.getElementById('burger');
        burger.classList.contains('cross') && burger.click();
    }
}
